"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var orderTagApi = _interopRequireWildcard(require("@/api/orderTagApi.js"));
var companyappApi = _interopRequireWildcard(require("@/api/companyappApi"));
var _openDetail = _interopRequireDefault(require("./openDetail.vue"));
var userApi = _interopRequireWildcard(require("@/api/user"));
var _componentsApi = require("@/api/componentsApi");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    OpenDetail: _openDetail.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      companyList: [],
      sendStatusList: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.initSearch();
    this.handlerGetListData(this.listPram);
  },
  methods: {
    checkPermi: _permission.checkPermi,
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      userApi.getSendLists(pram).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    // 查看明细
    openRecord: function openRecord(id) {
      var _this$$refs$OpenDetai;
      (_this$$refs$OpenDetai = this.$refs['OpenDetailRef']) === null || _this$$refs$OpenDetai === void 0 ? void 0 : _this$$refs$OpenDetai.openInit(id);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    userSourceFormat: function userSourceFormat(row, column, cellValue) {
      var map = {
        0: '全部',
        1: '游客',
        2: '工会人员'
      };
      return map[cellValue] || '-';
    },
    initSearch: function initSearch() {
      var _this2 = this;
      // 小程序列表
      this.companyList = [];
      companyappApi.customersListApi({
        types: 3
      }).then(function (res) {
        _this2.companyList = res || [];
      });
      this.sendStatusList = [];
      (0, _componentsApi.dictionaryGetListApi)({
        group: 'coupon_send_status'
      }).then(function (res) {
        _this2.sendStatusList = res;
      });
    }
  }
};